import { DisabledModeT } from "shared-ts/hooks/useFilter/types/filter.types"
import { PartialInterval } from "shared-ts/libs/dates/interval"

import { Button } from "../../../../components/base/control/Button"
import {
  VisualStateT,
  getVisualState,
} from "../../../../components/composite/TimestampRangePicker"
import { classNames } from "../../../../lib/classNames"

interface CalendarCellProps {
  date: Date
  range: PartialInterval | null
  displayMonth: Date
  currentlySelecting: "from" | "to"
  onDateClicked: (date: Date) => void
  disabledMode: DisabledModeT
}

export function CalendarCell({
  date,
  range,
  displayMonth,
  currentlySelecting,
  onDateClicked,
  disabledMode,
}: CalendarCellProps) {
  const visualState = getVisualState(
    date,
    range,
    currentlySelecting,
    displayMonth,
    disabledMode
  )
  return (
    <Button
      mode="ghost"
      className={classNames(
        "text-body size-8 items-center justify-center overflow-visible rounded-none font-normal focus:z-10",
        getClassName(visualState)
      )}
      disabled={visualState === "disabled"}
      onMouseDown={(e) => {
        e.preventDefault()
        onDateClicked(date)
      }}
      tabIndex={-1}
      size="small"
    >
      {date.getDate()}
    </Button>
  )
}

function getClassName(state: VisualStateT): string {
  const boundaryClassName = "color-button-white-default bg-primary-default"
  const classNameByState: Record<VisualStateT, string> = {
    disabled: "color-subtler",
    muted: "color-subtler",
    bolded: classNames(boundaryClassName, "rounded"),
    "left-bolded": classNames(boundaryClassName, "rounded-l"),
    "right-bolded": classNames(boundaryClassName, "rounded-r"),
    highlighted: "color-default bg-accent-blue",
    plain: "color-default rounded",
  }

  return classNameByState[state]
}
